import { useShallow } from 'zustand/shallow';

import { Catalogue } from 'app/modules/wallforming/components/catalogue-container/Catalogue';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const CatalogueContainer = () => {
    const settingTypeFilter = usePlacementStore(useShallow((state) => state.settingTypeFilter));
    return <Catalogue settingType={settingTypeFilter} />;
};
